import {registerRoot} from 'remotion';
import {Index} from './Video';

registerRoot(Index);
